'use server'

import { apiRequest, ApiResponse } from '../request'

export interface SystemResource {
    id: number
    key: string
    label: string
    sortOrder: number
    moduleId: number
    createdAt: string
    updatedAt: string
}

export interface SystemModule {
    id: number
    key: string
    label: string
    sortOrder: number
    // M:N: tiers aos quais o módulo pertence (gerenciado pelo form do tier).
    tiers?: { id: number; name: string }[]
    resources: SystemResource[]
    createdAt: string
    updatedAt: string
}

export interface CreateSystemResourceData {
    key: string
    label: string
    sortOrder?: number
}

export interface CreateSystemModuleData {
    key: string
    label: string
    sortOrder?: number
    resources?: CreateSystemResourceData[]
}

export interface UpdateSystemModuleData {
    label?: string
    sortOrder?: number
    resources?: CreateSystemResourceData[]
}

export async function getSystemModules(): Promise<
    ApiResponse<SystemModule[]>
> {
    return apiRequest<SystemModule[]>('system-modules', {})
}

export async function getSystemModule(
    id: number,
): Promise<ApiResponse<SystemModule>> {
    return apiRequest<SystemModule>(`system-modules/${id}`, {})
}

export async function createSystemModule(
    data: CreateSystemModuleData,
): Promise<ApiResponse<SystemModule>> {
    return apiRequest<SystemModule>('system-modules', { data }, 'post')
}

export async function updateSystemModule(
    id: number,
    data: UpdateSystemModuleData,
): Promise<ApiResponse<SystemModule>> {
    return apiRequest<SystemModule>(
        `system-modules/${id}`,
        { data },
        'patch',
    )
}

export async function deleteSystemModule(
    id: number,
): Promise<ApiResponse<void>> {
    return apiRequest<void>(`system-modules/${id}`, {}, 'delete')
}
